<template>
  <Breadcrumbs :breadcrumbs="breadcrumbs" />
  <section class="category-catalog">
    <div class="category-catalog__container">
      <h1 class="category-catalog__title">
        {{ _T("@Catalog") }}
      </h1>
      <div class="category-catalog__categories">
        <CatalogCard
          v-for="category in categories"
          :key="category.id"
          :category="category"
        />
      </div>
    </div>
    <ProductShowcase :tabs="labelCarouselTabs" />
    <div class="slider-footer">
      <SeenProductCarousel is-seen-added />
    </div>
  </section>
</template>

<script setup>
import SeenProductCarousel from "~/modules/shared/sliders/productCarousels/SeenProductCarousel.vue";
import { useCategoriesStore } from "~/store/categoriesStore";
import ProductShowcase from "~/modules/shared/productShowcase/ProductShowcase.vue";
import Breadcrumbs from "~/modules/shared/breadcrumbs/Breadcrumbs.vue";
import CatalogCard from "~/modules/catalog/ui/components/CatalogCard.vue";

const categoriesStore = useCategoriesStore();
const { getTopLevelCategories: categories } = storeToRefs(categoriesStore);

if (!categories.value) {
  throw showError({ statusCode: 404 });
}

const breadcrumbs = [
  {
    name: _T("@Catalog"),
    routeName: "catalog",
  },
];

const labelCarouselTabs = [
  {
    title: _T("@Novelties"),
    component: defineAsyncComponent(
      () =>
        import(
          "~/modules/shared/sliders/productCarousels/ProductCarouselByLabel.vue"
        ),
    ),
    label: "novelty",
  },
  {
    title: _T("@Popular"),
    component: defineAsyncComponent(
      () =>
        import(
          "~/modules/shared/sliders/productCarousels/ProductCarouselByLabel.vue"
        ),
    ),
    label: "bestSeller",
  },
];

useSeoMeta({
  title: _T("@Meta title catalog"),
  description: _T("@Meta description catalog"),
});
</script>

<style lang="scss" scoped>
.category-catalog {
  @extend %padding-wrp;

  @include flex-container(column, flex-start);
  gap: 24px;

  padding-bottom: 80px;

  &__container {
    @extend %width-main;

    @include flex-container(column, center, center);
    gap: 36px;

    margin: 0 auto;
  }

  &__title {
    @include font(36, 44, 700);
    letter-spacing: 0.36px;
    align-self: start;

    @include mobile {
      @include font(24, 32, 700);
      letter-spacing: 0.48px;
    }
  }

  &__categories {
    @extend %width-main;

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 8px;

    @include mobile {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
}

.slider-footer {
  @extend %width-main;
  margin: auto;
}
</style>
